import { useContext } from "react";
import { SignalRContext } from "../components";
import { SignalRActionItemsContext } from "../components/signalR/actionItems";
import { SignalRChatContext } from "../components/signalR/chat";
import { SignalRCommentsContext } from "../components/signalR/comments/SignalRCommentsContext";
import { SignalRIssuesContext } from "../components/signalR/issues";
import { SignalRMeetingsContext } from "../components/signalR/meetings";
import { SignalRNotificationsContext } from "../components/signalR/notifications/SignalRNotificationsContext";
import { SignalRPlansContext } from "../components/signalR/plans";
import { SignalRTaskItemsContext } from "../components/signalR/taskItems";

const useSignalR = () => {
  const signalRContext = useContext(SignalRContext);
  const signalRActionItemsContext = useContext(SignalRActionItemsContext);
  const signalRChatContext = useContext(SignalRChatContext);
  const signalRCommentsContext = useContext(SignalRCommentsContext);
  const signalRNotificationsContext = useContext(SignalRNotificationsContext);
  const signalRIssuesContext = useContext(SignalRIssuesContext);
  const signalRMeetingsContext = useContext(SignalRMeetingsContext);
  const signalRPlansContext = useContext(SignalRPlansContext);
  const signalRTaskItemsContext = useContext(SignalRTaskItemsContext);

  return {
    joinGroup: signalRContext.joinGroup,
    joinGroups: signalRContext.joinGroups,
    leaveGroup: signalRContext.leaveGroup,
    leaveGroups: signalRContext.leaveGroups,
    ...signalRActionItemsContext,
    ...signalRChatContext,
    ...signalRCommentsContext,
    ...signalRNotificationsContext,
    ...signalRIssuesContext,
    ...signalRMeetingsContext,
    ...signalRPlansContext,
    ...signalRTaskItemsContext,
  };
};

export { useSignalR };
